<div class="row" style="min-height: 150px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block deviceOptionsHeader">
          <sb-icon class="blue" icon="download"></sb-icon>&nbsp;
        </div>
        <div class="blue inline-block deviceOptionsHeader">
          &nbsp;{{ 'lang.device.downloadOfflinePlaylist' | translate }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <sb-radio-group [titles]="{ Neon: 'Neon', Smil: 'Smil' }"
                                [selections]="[ 'Neon', 'Smil' ]" (selected)="selectedType($event)"
                                [selectedVal]="preselectType ? preselectType : 'Neon'"></sb-radio-group>
              </p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <sb-button classes="btn-primary" (click)="download()" [disabled]="loading"
                           [loading]=loading>
                  &nbsp;<sb-icon icon="download"></sb-icon>&nbsp;{{ 'lang.globals.download' | translate }}
                </sb-button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
